/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Resources_TitleInputs */

const en_blog_resources_title = /** @type {(inputs: Blog_Resources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore while the journal grows`)
};

const zh_blog_resources_title = /** @type {(inputs: Blog_Resources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在刊物更新前继续探索`)
};

/**
* | output |
* | --- |
* | "Explore while the journal grows" |
*
* @param {Blog_Resources_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_resources_title = /** @type {((inputs?: Blog_Resources_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Resources_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_resources_title(inputs)
	return zh_blog_resources_title(inputs)
});
export { blog_resources_title as "blog.resources_title" }